/**
 * Shallow case converters used at the PostgREST boundary for tables whose
 * Drizzle types are camelCase (TS convention) but whose actual DB columns are
 * snake_case (Postgres convention). PostgREST mirrors DB column names verbatim,
 * so any table that crosses this boundary needs the conversion done by hand.
 */

export function snakeToCamel(obj: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(obj)) {
    out[k.replace(/_([a-z])/g, (_, c) => c.toUpperCase())] = v;
  }
  return out;
}

export function camelToSnake(obj: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(obj)) {
    out[k.replace(/[A-Z]/g, (c) => '_' + c.toLowerCase())] = v;
  }
  return out;
}
